namespace Solovis.UI.Icons {

    export function createEntityIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-circle");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createTagIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-tag");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createInvestmentIcon(cssRules?) {
        var iconDiv = $("<div>")
            .css({
                "display": "inline-block",
                "position": "relative"
            });

        $("<span>")
            .addClass("fa fa-circle")
            .css({
                "position": "relative",
                "top": "-2px",
                "left": "2px",
                "font-size": "7px"
            })
            .appendTo(iconDiv);

        $("<span>")
            .addClass("fa fa-minus")
            .css({
                "font-size": "7px",
                "position": "relative",
                "top": "-2px"
            })
            .appendTo(iconDiv);

        $("<span>")
            .addClass("fa fa-circle")
            .css({
                "position": "relative",
                "top": "-2px",
                "left": "-2px",
                "font-size": "7px"
            })
            .appendTo(iconDiv);

        if (cssRules) {
            iconDiv.css(cssRules);
        }

        return iconDiv;
    }

    export function createContactIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-group");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createManagerIcon(cssRules?) {
        const size = '16px';
        const iconSpan = $("<span>").append(
            $(`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
  >
    <path
      fill="currentcolor"
      d="M680-119q-8 0-16-2t-15-7l-120-70q-14-8-21.5-21.5T500-249v-141q0-16 7.5-29.5T529-441l120-70q7-5 15-7t16-2q8 0 15.5 2.5T710-511l120 70q14 8 22 21.5t8 29.5v141q0 16-8 29.5T830-198l-120 70q-7 4-14.5 6.5T680-119ZM400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-8 18-13.5 37.5T404-360h-4q-71 0-127.5 18T180-306q-9 5-14.5 14t-5.5 20v32h252q6 21 16 41.5t22 38.5H80Zm320-400q33 0 56.5-23.5T480-640q0-33-23.5-56.5T400-720q-33 0-56.5 23.5T320-640q0 33 23.5 56.5T400-560Zm0-80Zm12 400Zm174-166 94 55 94-55-94-54-94 54Zm124 208 90-52v-110l-90 53v109Zm-150-52 90 53v-109l-90-53v109Z"
    />
  </svg>`)
                .css({ width: size, height: size, minWidth: size, minHeight: size, verticalAlign: 'top'})
        );

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createReportIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-bar-chart");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createUserIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-user");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createMoreResultsIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-search");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createTagsIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("glyphicon glyphicon-tags");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }
}